
    import * as Rax from './index.js';
    if (typeof module !== 'undefined') module.exports = Rax;
    else self.Rax = Rax;
    